import { useMemo, type ComponentProps } from "react";

import type { ChillnnStudioDriver } from "@/lib/chillnn-studio-driver";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { HPBSnackOrSnackBaseSettingsDialog } from "@/components/features/snack/_shared/ui/base-settings-dialog";
import { SnackThumbnailField } from "@/components/features/snack/_shared/ui/thumbnail-field";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { SnackFormModelType } from "../../../create-new-item/model/usecase/use-create-snack-form-model";

type ChillnnStudioDriverComponentProps = ComponentProps<typeof ChillnnStudioDriver>;

type Props = {
	isShow: boolean;
	handleClickSaveButton: () => void;

	snackFormModel: SnackFormModelType;

	imageRepository: ChillnnStudioDriverComponentProps["editorProps"]["imageRepository"];
	imageDeleter: ChillnnStudioDriverComponentProps["editorProps"]["imageDeleter"];
	imageUploader: ChillnnStudioDriverComponentProps["editorProps"]["imageUploader"];
};

export const SnackBaseSettingsDialog = ({
	isShow, //
	handleClickSaveButton,

	snackFormModel,

	imageRepository,
	imageUploader,
}: Props) => {
	const { methods, viewModel } = snackFormModel;
	const { title, description, thumbnail, isParentTemplate, slug } = viewModel;
	const { onSetDescription, onSetIsTemplate, onSetSlug, onSetThumbnail, onSetTitle } = methods;
	const canClickSaveButton = useMemo(() => !viewModel.hasError, [viewModel.hasError]);

	return (
		<>
			<HPBSnackOrSnackBaseSettingsDialog
				isShow={isShow}
				handleClickSaveButton={handleClickSaveButton}
				canClickSaveButton={canClickSaveButton}
			>
				<QuestionForMain
					required={true}
					title={"タイトル"}
					inputChildren={
						<InputTextField value={title.value} errorMessage={title.error} handleChange={onSetTitle} />
					}
				/>
				<QuestionForMain
					required={true}
					title={"サムネイル"}
					inputChildren={
						<SnackThumbnailField
							thumbnail={thumbnail}
							imageRepository={imageRepository}
							imageUploader={imageUploader}
							onSetThumbnail={onSetThumbnail}
						/>
					}
				/>
				<QuestionForMain
					required={false}
					title={"説明"}
					inputChildren={
						<InputTextField
							value={description?.value}
							errorMessage={description?.error}
							handleChange={onSetDescription}
						/>
					}
				/>
				<QuestionForMain
					required={false}
					title={"スラッグ（URL）"}
					inputChildren={
						<InputTextField value={slug?.value} errorMessage={slug?.error} handleChange={onSetSlug} />
					}
				/>
				<QuestionForMain
					required={false}
					title={"テンプレート設定"}
					inputChildren={
						<CheckboxField
							value={isParentTemplate?.value ?? false}
							errorMessage={isParentTemplate?.error}
							label={"共通テンプレートにする"}
							handleChange={onSetIsTemplate}
						/>
					}
				/>
			</HPBSnackOrSnackBaseSettingsDialog>
		</>
	);
};

SnackBaseSettingsDialog.displayName = "SnackBaseSettingsDialog";
